module.exports = __webpack_public_path__ + "static/media/IMG-5.f19e2c6c.jpg";